import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    GetAttachmentsForContact as GetAttachmentsForContactQuery,
    GetAttachmentsForContact_contact_files as File,
    GetAttachmentsForContactVariables,
} from 'nutshell-graphql-types';

import GET_ATTACHMENTS_FOR_CONTACT from '../queries/get-attachments-for-contact.graphql';

export const useGetAttachmentsForContact = (
    contactId: string
): {
    files: File[] | null | undefined;
    isLoading: boolean;
    error: string | null | undefined;
    refetch: () => Promise<any>;
} => {
    const {loading, data, error, refetch} = useQuery<
        GetAttachmentsForContactQuery,
        GetAttachmentsForContactVariables
    >(GET_ATTACHMENTS_FOR_CONTACT, {
        variables: {
            contactId,
        },
        fetchPolicy: 'cache-and-network',
    });

    return {
        files: data && data.contact && data.contact.files,
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
        refetch,
    };
};
